
import StarsIcon from '@mui/icons-material/Stars';
import DiamondIcon from '@mui/icons-material/Diamond';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import HealingIcon from '@mui/icons-material/Healing';
import AddIcon from '@mui/icons-material/Add';
import RocketIcon from '@mui/icons-material/Rocket';
import EventSeatIcon from '@mui/icons-material/EventSeat';

import HomeIcon from '@mui/icons-material/Home';
import FlagIcon from '@mui/icons-material/Flag';
import LanguageIcon from '@mui/icons-material/Language';

import StarIcon from '@mui/icons-material/Star';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import PublicIcon from '@mui/icons-material/Public';

import HdrAutoIcon from '@mui/icons-material/HdrAuto';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SpaIcon from '@mui/icons-material/Spa';
import ModeStandbyIcon from '@mui/icons-material/ModeStandby';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import WorkIcon from '@mui/icons-material/Work';
import PaidIcon from '@mui/icons-material/Paid';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import SearchIcon from '@mui/icons-material/Search';
import BlockIcon from '@mui/icons-material/Block';
import TuneIcon from '@mui/icons-material/Tune';

import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import DescriptionIcon from '@mui/icons-material/Description';
import MessageIcon from '@mui/icons-material/Message';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import CheckIcon from '@mui/icons-material/Check';
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';

import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import KeyIcon from '@mui/icons-material/Key';
import SyncIcon from '@mui/icons-material/Sync';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';

import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import SortIcon from '@mui/icons-material/Sort';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import LandscapeOutlinedIcon from '@mui/icons-material/LandscapeOutlined';
import AlignVerticalCenterOutlinedIcon from '@mui/icons-material/AlignVerticalCenterOutlined';

import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import { getIndexColor } from './colorUtils';
import { StringToStringMap } from '../types/common';
import { PlayerLocality, PlayerRole } from '../types/player';
import { AvailabilityStatus, FormStatus } from '../types/scouting';
import { SeasonSubConditionStatus } from '../types/clause';
import { AggregationRule } from '../types/tenant';
import { PlannerActionType } from '../types/planner';
import { AccessType, ReportAccess, LogisticTeamAccess } from '../types/user';
import { ReportType } from '../types/report';


const defaultIconColorMap: StringToStringMap = {
  'dark': '#2f3441',
  'light': '#ffffffdd'
};


export const getRoleIcon = (
  role: PlayerRole | null | undefined,
  fontSize: number,
  iconColor?: string,
  tenantLightColor?: string,
  returnAddIfNoRole?: boolean
) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (role === 'keyPlayer') {
    if (tenantLightColor) {
      return (
        <div
          style={{
            position: 'relative',
            height: fontSize,
            width: fontSize,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <StarsIcon style={{ fontSize: fontSize, color: iconColor, zIndex: 1 }} />
          <div
            style={{
              position: 'absolute',
              height: fontSize - 6,
              width: fontSize - 6,
              borderRadius: 100,
              backgroundColor: tenantLightColor,
            }}
          />
        </div>
      );
    }
    return <StarsIcon style={{ fontSize: fontSize, color: iconColor, zIndex: 1 }} />;
  }

  if (role === 'valuePlayer') return <DiamondIcon style={{ fontSize: fontSize, color: iconColor, marginBottom: -1 }} />;
  if (role === 'rotationPlayer') return <GroupIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'loanedIn') return <CreditCardIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'developmentPlayer') return <RocketIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'reserve') return <EventSeatIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'longTermInjured') return <HealingIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'loanedOut') return <PersonOffIcon style={{ fontSize: fontSize, color: iconColor }} />;

  if (role === 'trialist') return <HdrAutoIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'highPotentialPlayer') return <StarIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'performancePlayer') return <SpaIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'outplacementPlayer') return <ExitToAppIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (role === 'transferTarget') return <ModeStandbyIcon style={{ fontSize: fontSize, color: iconColor }} />;

  if (returnAddIfNoRole) return <AddIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getLocalityIcon = (locality: PlayerLocality, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (locality === 'local') return <HomeIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (locality === 'national') return <FlagIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (locality === 'international') return <LanguageIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getAccessIcon = (access: AccessType, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (access === 'admin') return <AdminPanelSettingsIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'full') return <WorkIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'economy') return <PaidIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'scout') return <TravelExploreIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'limitedScout') return <SearchIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'academy') return <SchoolIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'none') return <BlockIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (access === 'custom') return <TuneIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const accessTableOptionToColorMap: StringToStringMap = {
  'full': '#2bff3d',
  'personal': '#ffe44e',
  'academy': '#61b8ff',
  'none': '#ff4848',
};


export const getAccessTableOptionIcon = (accessOptions: LogisticTeamAccess | ReportAccess, fontSize: number, iconColor?: string | 'colored') => {

  iconColor = iconColor === 'colored' ? accessTableOptionToColorMap[accessOptions] : iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (accessOptions === 'full') return <CheckIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (accessOptions === 'personal') return <PersonIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (accessOptions === 'academy') return <SchoolIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (accessOptions === 'none') return <CloseIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getReportIcon = (reportType: ReportType, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (reportType === 'ScoutingReport') return <PlagiarismIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (reportType === 'MatchReport') return <DescriptionIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (reportType === 'Comment') return <MessageIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (reportType === 'Attachment') return <PictureAsPdfIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


// get icon for specific team
export const getTeamIcon = (currentTeam: string | undefined, fontSize: number, iconColor?: string, isAcademyTeam?: boolean) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (currentTeam === 'ownTeam') return <GroupIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeam === 'masterTeam') return <StarIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeam === 'shadowTeam') return <SportsSoccerIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (isAcademyTeam) return <SchoolIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeam) return <PublicIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


// get icon to best represent the current team (the player can be in multiple teams, in which case we want to show the icon with the highest priority)
export const getCurrentTeamIcon = (currentTeams: { teamId: string, isAcademyTeam: boolean }[], fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (currentTeams.some(entry => entry.teamId === 'ownTeam')) return <GroupIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeams.some(entry => entry.teamId === 'masterTeam')) return <StarIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeams.some(entry => entry.teamId === 'shadowTeam')) return <SportsSoccerIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeams.some(entry => !entry.isAcademyTeam)) return <PublicIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (currentTeams.some(entry => entry.isAcademyTeam)) return <SchoolIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getPlayingTimeIcon = (playingTimeKey: AvailabilityStatus, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (playingTimeKey === 'KEY') return <KeyIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (playingTimeKey === 'ROTATION') return <SyncIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (playingTimeKey === 'RESERVE') return <AcUnitIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (playingTimeKey === 'UNKNOWN') return <RemoveOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getFormIcon = (formKey: FormStatus, fontSize: number, iconColor?: string, lightness?: number) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (formKey === 'IN_FORM') {
    return (
      <div
        style={{
          position: 'relative',
          height: fontSize,
          width: fontSize,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <ArrowDropUpIcon
          style={{
            position: 'absolute',
            fontSize: fontSize + 12,
            color: lightness ? getIndexColor(10, lightness) : iconColor,
          }}
        />
      </div>
    );
  }

  if (formKey === 'NORMAL_FORM') return <TrendingFlatIcon style={{ fontSize: fontSize, color: iconColor }} />;

  if (formKey === 'OUT_OF_FORM') {
    return (
      <div
        style={{
          position: 'relative',
          height: fontSize,
          width: fontSize,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <ArrowDropDownIcon
          style={{
            position: 'absolute',
            fontSize: fontSize + 12,
            color: lightness ? getIndexColor(0, lightness) : iconColor,
          }} />
      </div>
    );
  }

  if (formKey === 'NO_FORM') return <RemoveOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getConditionStatusIcon = (status: SeasonSubConditionStatus, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (status === 'achieved') return <TaskAltIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (status === 'notAchieved') return <CancelOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


export const getAggregationRuleIcon = (aggregationRule: AggregationRule, fontSize: number, iconColor?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : undefined;

  if (aggregationRule === 'priority') return <SortIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (aggregationRule === 'max') return <LandscapeOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (aggregationRule === 'average') return <AlignVerticalCenterOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
  if (aggregationRule === 'confidence') return <CircleOutlinedIcon style={{ fontSize: fontSize, color: iconColor }} />;
};


const plannerActionToColorMap: StringToStringMap = {
  'playerAdded': '#75e96f',
  'contractExtended': '#75e96f',
  'playerRemoved': '#e96565',
  'contractExpired': '#e96565',
  'positionChanged': '#8ac0ed',
  'roleChanged': '#8ac0ed',
  'localityChanged': '#8ac0ed',
};


export const getPlannerActionIcon = (plannerAction: PlannerActionType, fontSize: number, iconColor?: string, role?: string, locality?: string) => {

  iconColor = iconColor ? defaultIconColorMap[iconColor] ?? iconColor : (
    plannerActionToColorMap[plannerAction] ?? defaultIconColorMap['light']
  );

  if (plannerAction === 'roleChanged' && role) return getRoleIcon(role as PlayerRole, fontSize, iconColor);
  if (plannerAction === 'localityChanged' && locality) return getLocalityIcon(locality as PlayerLocality, fontSize, iconColor);

  if (plannerAction === 'playerAdded') return <PersonAddAlt1Icon style={{ fontSize: fontSize, color: iconColor, marginRight: -2 }} />;
  if (plannerAction === 'playerRemoved') return <PersonRemoveAlt1Icon style={{ fontSize: fontSize, color: iconColor, marginRight: -2 }} />;
  if (plannerAction === 'contractExtended') return <EventAvailableIcon style={{ fontSize: fontSize, color: iconColor, marginBottom: -1 }} />;
  if (plannerAction === 'contractExpired') return <EventBusyIcon style={{ fontSize: fontSize, color: iconColor, marginBottom: -1 }} />;
  if (
    plannerAction === 'positionChanged' || plannerAction === 'roleChanged' || plannerAction === 'localityChanged'
  ) return <ManageAccountsIcon style={{ fontSize: fontSize, color: iconColor, marginRight: -2 }} />;
};
